const external = {
  path: '/external',
  name: 'external',
  component: () => import('@/views/external'),
  redirect: '/external/styleLibrary',
  meta: {
    title: '设计在线'
  },
  children: [
    {
      path: 'styleLibrary/:wxFlockId',
      name: 'externalStyleLibrary',
      component: () => import('@/views/external/solutionLibrary/styleLibrary'),
      meta: {
        title: '风格设计方案库'
      },
      props: true
    },
    {
      path: 'spaceLibrary/:wxFlockId/:styleId/:spaceId/:moduleId',
      name: 'externalSpaceLibrary',
      component: () => import('@/views/external/solutionLibrary/spaceLibrary'),
      meta: {
        title: '空间设计方案库'
      },
      props: true
    },
    {
      path: 'spaceSchemeContent/:spaceProgramId/:wxFlockId',
      name: 'externalSpaceSchemeContent',
      component: () => import('@/views/external/solutionLibrary/spaceLibrary/content.vue'),
      meta: {
        title: '方案参考库'
      },
      props: true
    },
    {
      path: 'styleSchemeContent/:styleProgramId/:wxFlockId',
      name: 'externalStyleSchemeContent',
      component: () => import('@/views/external/solutionLibrary/styleLibrary/content.vue'),
      meta: {
        title: '方案参考库'
      },
      props: true
    },
    {
      path: 'assignment-detail_wx',
      name: 'assignment-detail_wx',
      component: () => import('@/views/external/assignment-detail_wx'),
      meta: {
        title: '客诉处理'
      }
    },
    {
      path: 'handle-detail_wx',
      name: 'handle-detail_wx',
      component: () => import('@/views/external/handle-detail_wx'),
      meta: {
        title: '客诉处理'
      }
    },
    {
      path: 'construction-progress',
      name: 'external-construction-progress',
      component: () => import('@/views/external/construction-progress'),
      meta: {
        title: '施工进度排期表'
      }
    },
    {
      path: 'serviceManual-explain',
      name: 'serviceManual-explain',
      component: () => import('@/views/wxapp/designer-manager/serviceManual/explain'),
      meta: {
        title: '服务手册'
      }
    },
    {
      path: 'serviceManual-explain-details',
      name: 'serviceManual-explain-details',
      component: () => import('@/views/wxapp/designer-manager/serviceManual/explain/details'),
      meta: {
        title: '服务手册'
      }
    },
    // 勘测邀请函封面
    {
      path: 'invitation-look-cover',
      name: 'InvitationLook',
      component: () => import('@/views/wxapp/customer-manager/unDesigner/envelope'),
      meta: {
        title: '勘测邀请函封面'
      }
    },
    // 勘测邀请函结果页
    {
      path: 'invitation-result',
      name: 'InvitationLook',
      component: () => import('@/views/wxapp/customer-manager/unDesigner/invitationLook'),
      meta: {
        title: '勘测邀请函'
      }
    },
    // 委托设计邀请函封面
    {
      path: 'commissioned-design-invite-cover',
      name: 'InvitationCover',
      component: () => import('@/views/wxapp/customer-manager/commissionedDesign/envelope'),
      meta: {
        title: '委托设计邀请函封面'
      }
    },
    // 委托设计结果页
    {
      path: 'created-invitationLook',
      name: 'CreatedInvitationLook',
      component: () => import('@/views/wxapp/customer-manager/commissionedDesign/invitationLook'),
      meta: {
        title: '委托设计结果'
      }
    },
    {
      path: 'question-feedback',
      name: 'QuestionFeedback',
      component: () => import('@/views/external/question-feedback'),
      meta: {
        title: '客诉处理'
      }
    }
  ]
}

export default external
